export default "__VITE_ASSET__5ee48fa9__"